export default __webpack_public_path__ + "static/media/wh_icon_Concrete-5.1881bfb5.svg";